import { Component, Inject, Input } from "@angular/core";

import { FieldOkItemComponent } from "@softline/dynamic";

@Component({
    selector: 'soft-ktostamm-kunde-subnummer-master-view',
    imports: [],
    templateUrl: './ktostamm-kunde-subnummer.master-view.html',
    styleUrls: ['./ktostamm-kunde-subnummer.master-view.css']
})
export class KtostammKundeSubnummerMasterView implements FieldOkItemComponent<any>{
  @Input() item: any;
}
